module.exports = __webpack_public_path__ + "static/img/join_us_2.46a87167.png";